export default {"src":"/_next/static/media/Content-1.b5ae707a.svg","height":449,"width":702};